import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/lib/api";

let onUnauthorized: (() => void) | undefined;

/** The router registers this so any 401 from a query or mutation sends the user to /login. */
export function setUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn;
}

const handle = (error: unknown) => {
  if (error instanceof ApiError && error.isUnauthorized) onUnauthorized?.();
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handle }),
  mutationCache: new MutationCache({ onError: handle }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Client errors (4xx) will not fix themselves; transient failures get two retries.
      retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
    },
  },
});
